import { createViewportService } from '../class/service/ViewportService';

export const viewportService = createViewportService();
